import { http, API } from "../../store/API";
export default {
    state: {
        invoices: [],
        totalInvoices: 0,
        invoice: null,
        shipment_details: null,
    },
    getters: {
        invoices: ({ invoices }) => invoices,
        invoice: ({ invoice }) => invoice,
        shipment_details: ({ shipment_details }) => shipment_details,
    },
    mutations: {
        save_data(state, { key, value }) {
            state[key] = value;
        },
    },
    actions: {
        INVOICES: async ({ rootState, commit }, { service, filter }) => {
            try {
                let response = await http.post(
                    API[service] + filter,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${rootState.user.token}`,
                        },
                    }
                );
                commit("save_data", {
                    key: "invoices",
                    value: response.data.data.data,
                });
                commit("save_data", {
                    key: "totalInvoices",
                    value: response.data.data.total,
                });
                return;
            } catch (e) {
                throw {
                    message: "Invalid email/phone number or password",
                    data: e,
                };
            }
        },
        INVOICE: async ({ rootState, commit }, { service, reqPayload }) => {
            try {
                let response = await http.get(API[service] + reqPayload, {
                    headers: {
                        Authorization: `Bearer ${rootState.user.token}`,
                    },
                });
                commit("save_data", {
                    key: "invoice",
                    value: response.data.data,
                });
                return;
            } catch (e) {
                throw {
                    message: "Invalid email/phone number or password",
                    data: e,
                };
            }
        },
        SHIPMENT_DETAILS: async (
            { rootState, commit },
            { service, reqPayload }
        ) => {
            try {
                let response = await http.get(API[service] + reqPayload, {
                    headers: {
                        Authorization: `Bearer ${rootState.user.token}`,
                    },
                });
                commit("save_data", {
                    key: "shipment_details",
                    value: response.data.data,
                });
                return;
            } catch (e) {
                throw {
                    message: "Invalid email/phone number or password",
                    data: e,
                };
            }
        },
    },
};
